import { Box, Table, TableBody, TableContainer } from "@material-ui/core";
import CssPagination from "src/components/Pagination/CssPagination";
import TitleTypography from "src/components/Typography/TitleTypography";
import usePagination from "src/hooks/usePagination";
import MarketEventTableHeader from "./MarketEventTableHeader";
import MarketEventTableRow from "./MarketEventTableRow";

export default function MarketEventTable({ data }) {
  const len = data.length;
  const { data: paginationData, jump, maxPage, currentPage } = usePagination(data);

  return (
    <>
      <TableContainer style={{ borderRadius: "10px", marginTop: "2rem" }}>
        <Table>
          <MarketEventTableHeader />
          <TableBody>
            {paginationData.map((element, index) => {
              return <MarketEventTableRow key={index} rowData={element} />;
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {len === 0 && (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%" mt={2}>
          <TitleTypography textProps={{ variant: "h5" }} title="Click on chart to see data" />
        </Box>
      )}
      {len > 0 && (
        <CssPagination
          mt={1}
          paginationProps={{ page: currentPage, count: maxPage, onChange: (_, page) => jump(page) }}
        />
      )}
    </>
  );
}
